import Accordion from './accordion';

const accordionConfig = {
  name: 'accordion',
  class: Accordion,
  querySelector: {
    controller: '.accordion-controller',
    content: '.accordion-content',
  },
  querySelectorAll: {},
  options: {},
};

export default accordionConfig;
